import { appInsights } from '../telemetryConfig';

export class TelemetryService {
  static trackEvent(name: string, properties?: Record<string, any>, measurements?: Record<string, number>) {
    if (appInsights?.appInsights) {
      appInsights.trackEvent({ name, properties, measurements });
    }
  }

  static trackException(error: Error, properties?: Record<string, any>) {
    if (appInsights?.appInsights) {
      appInsights.trackException({ exception: error, properties });
    }
  }

  static trackApiCall(name: string, url: string, duration: number, success: boolean, responseCode: number = 200, properties?: Record<string, any>) {
    if (appInsights?.appInsights) {
      appInsights.trackDependencyData({
        id: `${name}_${Date.now()}`,
        responseCode: responseCode,
        target: url,
        name: name,
        duration: duration,
        success: success,
        properties: properties
      });
    }
  }

  static trackUserAction(action: string, properties?: Record<string, any>) {
    this.trackEvent(`UserAction_${action}`, properties);
  }

  static trackPageView(name?: string, properties?: Record<string, any>) {
    if (appInsights?.appInsights) {
      appInsights.trackPageView({ name, properties });
    }
  }

  static trackPerformance(name: string, duration: number, properties?: Record<string, any>) {
    this.trackEvent(`Performance_${name}`, properties, { duration });
  }
}
